/**
 * OneQrew Card Component
 *
 * Card-Komponente nach Brand Guide:
 * - Radius = 32px
 * - Padding = 32px (Radius-Padding-Regel!)
 * - Schatten nach OneQrew Shadows
 */

import { Card as MuiCard } from '@mui/material';
import { styled } from '@mui/material/styles';
import { borderRadius, spacing, shadows } from '../../theme/tokens';

export const OneQrewCard = styled(MuiCard)(({ theme }) => ({
  borderRadius: borderRadius.xxs, // 8px Standard
  padding: spacing.xs, // 8px (Radius = Padding Rule!)
  boxShadow: shadows.sm,
  transition: 'all 0.2s ease-in-out',
  backgroundColor: theme.palette.background.paper,

  '&:hover': {
    boxShadow: shadows.md,
  },

  // Varianten
  '&.card-elevated': {
    boxShadow: shadows.md,
    '&:hover': {
      boxShadow: shadows.lg,
    },
  },

  '&.card-flat': {
    boxShadow: 'none',
    border: `1px solid ${theme.palette.divider}`,
  },

  '&.card-medium': {
    padding: spacing.md, // 24px
    borderRadius: borderRadius.s, // 24px
  },

  '&.card-large': {
    padding: spacing.lg, // 32px
    borderRadius: borderRadius.m, // 32px
  },
}));

export default OneQrewCard;
